<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2Zm0 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm1-.91V4.07c1.46.18 2.79.76 3.9 1.62L13 9.59Zm-2 0-3.9-3.9A7.94 7.94 0 0 1 11 4.07v5.52ZM9.59 11H4.07a7.94 7.94 0 0 1 1.62-3.9l3.9 3.9Zm0 2-3.9 3.9A7.94 7.94 0 0 1 4.07 13h5.52ZM11 14.41v5.52a7.94 7.94 0 0 1-3.9-1.62l3.9-3.9Zm2 0 3.9 3.9a7.94 7.94 0 0 1-3.9 1.62v-5.52ZM14.41 13h5.52a7.94 7.94 0 0 1-1.62 3.9l-3.9-3.9Zm0-2 3.9-3.9a7.94 7.94 0 0 1 1.62 3.9h-5.52Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
